import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogDismiss,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
  buttonVariants,
} from '@barfacil/barfacil-ui'
import { Info } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { FormUpdateProduct } from '@/app/panel/management/price-list/_schemas/update-product'

type UpdateProductNameConfirmationDialogProps = {
  open: boolean
  onOpenChange(open: boolean): void
  onSubmit: (data: FormUpdateProduct) => Promise<void>
}

export const UpdateProductNameConfirmationDialog = ({
  open,
  onOpenChange,
  onSubmit,
}: UpdateProductNameConfirmationDialogProps) => {
  const form = useFormContext<FormUpdateProduct>()

  function handleSubmitConfirm() {
    return form.handleSubmit(async (data) => {
      await onSubmit(data)
      onOpenChange(false)
    })()
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mb-2">
            <Info className="text-sky-800" size={28} />
          </div>

          <AlertDialogTitle>ALTERAR DESCRIÇÃO DO PRODUTO</AlertDialogTitle>

          <AlertDialogDescription>
            Ao modificar a descrição do produto, todos os relatórios anteriores
            à alteração serão atualizados. Deseja confirmar?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="sm:justify-self-end">
          <AlertDialogCancel
            className={buttonVariants({ variant: 'tertiary' })}
          >
            CANCELAR
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              className="sm:w-32"
              disabled={form.formState.isSubmitting}
              isLoading={form.formState.isSubmitting}
              onClick={handleSubmitConfirm}
            >
              CONFIRMAR
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>

        <AlertDialogDismiss className="absolute right-6 top-6" />
      </AlertDialogContent>
    </AlertDialog>
  )
}
